export default __webpack_public_path__ + "static/media/bg-auth.20c1e58d.svg";